<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom"
            sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts allow-downloads">
    </iframe>
  </div>
</template>

<script>
  import request from '../../api/nesting';

  export default {
    name: 'checkOrderCreate',
    data() {
      return {
        getPageUrl: ''
      };
    },
    created() {
      request.getCoalSupplySynergyUrl({
        configUrlType: '14'
      }).then(res => {
        if (res.status) {
          this.getPageUrl = res.data.configUrl;
        }
      });
    }
  };
</script>

<style lang="scss" scoped>
  /** iframe样式 */
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>